<ion-avatar 
    class="logo_operation"
    [class.big]="this.sizeLogo === 'big'"
    [class.small]="this.sizeLogo === 'small'"
    [class.with_margin_right]="this.withMarginRight"
    >
    <img 
        [src]="this.getUrlLogo()" 
        [alt]="this.operationLogo.operation" 
        [title]="this.operationLogo.operation" 
        (error)="this.onImgError($event)"
        />
</ion-avatar>